import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { showTerms } from "../../../modules/dialog";

import walmartClassicLogo from "../../../images/walmartHeader/classic@2x.png";
import samsClubLogo from "../../../images/walmartHeader/samsClub@2x.png";
import walmartGtsLogo from "../../../images/walmartHeader/walmartGts@2x.png";

import styles from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { PRIVACY_POLICY } from "../../constants";
import { THEME_GLOBAL_TECHNOLOGY, THEME_SAM_CLUB } from "../../constants";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { getTranslation } from "../../../locales";

function getImageBasedOnTheme(themeName) {
  switch (themeName) {
    case THEME_GLOBAL_TECHNOLOGY:
      return walmartGtsLogo;
    case THEME_SAM_CLUB:
      return samsClubLogo;
    default:
      return walmartClassicLogo;
  }
}

const useStyles = makeStyles((props) => styles(props));

function Footer(props) {
  const [surveyPolicy, setSurveyPolicy] = useState(PRIVACY_POLICY);
  const [selectedPolicy, setSelectedPolicy] = useState([]);
  const [disableFlag, setDisableFlag] = useState(false);
  const theme = useTheme();
  const { survey } = useSelector((state) => state);
  const { currentSurveyId } = survey;
  const stringified = JSON.stringify(survey.data);
  const dispatch = useDispatch();
  const linkRef = [];

  const handleTermsAndConditions = () => {
    dispatch(showTerms());
  };

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Enter" || event.keyCode === 32) {
      event.target.querySelector("a").click();
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  useEffect(() => {
    if (survey && survey.currentSurveyId) {
      const { currentSurveyId } = survey;
      if (currentSurveyId) {
        const { thirdPartySettings } = survey.data[currentSurveyId];

        if (
          thirdPartySettings &&
          thirdPartySettings.selected_policy &&
          thirdPartySettings.selected_policy.length > 1
        ) {
          setSelectedPolicy([...thirdPartySettings.selected_policy]);
        }

        if (
          thirdPartySettings &&
          thirdPartySettings.selected_policy &&
          thirdPartySettings.selected_policy.length == 1
        ) {
          setSelectedPolicy([...thirdPartySettings.selected_policy]);
          setSurveyPolicy(thirdPartySettings.selected_policy[0].policy_link);
        }

        if (
          thirdPartySettings &&
          thirdPartySettings.selected_policy &&
          thirdPartySettings.selected_policy[0].policy_name.toLowerCase() == // Temporary fix for now
            "canada"
        ) {
          setDisableFlag(true);
        } else {
          setDisableFlag(false);
        }
      }
    }
  }, [stringified]);

  let logo = walmartClassicLogo;
  if (currentSurveyId && survey.data && survey.data[currentSurveyId]) {
    const { theme } = survey.data[currentSurveyId].thirdPartySettings;
    logo = getImageBasedOnTheme(theme);
  }

  const handleMenuItemClick = (e, index) => {
    linkRef[index].click();
    handleClose(e);
  };

  // const copyRightYeare = new Date().getFullYear();
  const classes = useStyles(theme);

  return (
    <div className={classes.container}>
      <div className={classes.footerContent}>
        <img
          src={logo}
          width={24}
          height={24}
          className={classes.footerLogo}
          alt={getTranslation(
            props.currentLang || "en",
            "surveyTaker:footerLogo"
          )}
        />
        <span className={classes.footerCopyrightLinks} data-testid="walmart">
          {" "}
          &#169;{" "}
          {getTranslation(
            props.currentLang || "en",
            "surveyTaker:walmart"
          )}{" "}
        </span>

        {!props.isMobile && (
          <div className={classes.footerRightDiv}>
            {!disableFlag ? (
              <Button
                className={classes.footerLinksTerms}
                onClick={handleTermsAndConditions}
                data-testid="termsOfUse"
              >
                {" "}
                {getTranslation(
                  props.currentLang || "en",
                  "surveyTaker:termsOfUse"
                )}{" "}
              </Button>
            ) : null}

            {selectedPolicy && selectedPolicy.length == 1 && (
              <a
                className={classes.footerLinksPrivacy}
                href={surveyPolicy}
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                {getTranslation(
                  props.currentLang || "en",
                  "surveyTaker:privacyPolicy"
                )}{" "}
              </a>
            )}

            {selectedPolicy && selectedPolicy.length > 1 && (
              <div className={classes.footerLinksPrivacyy}>
                <Button
                  className={classes.privacyButton}
                  onClick={handleToggle}
                  aria-expanded={open ? "true" : "false"}
                >
                  <InputLabel
                    className={classes.footerLabel}
                    ref={anchorRef}
                    id="composition-button"
                    aria-controls={open ? "composition-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-haspopup="true"
                    data-testid="privacyPolicy"
                  >
                    {getTranslation(
                      props.currentLang || "en",
                      "surveyTaker:privacyPolicy"
                    )}{" "}
                    {open ? (
                      <ArrowDropUpIcon
                        fontSize="small"
                        style={{ float: "right" }}
                      />
                    ) : (
                      <ArrowDropDownOutlinedIcon
                        fontSize="small"
                        style={{ float: "right" }}
                      />
                    )}
                  </InputLabel>
                </Button>

                <Popper
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  placement="bottom-start"
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom-start"
                            ? "left top"
                            : "left bottom",
                      }}
                    >
                      <Paper
                        style={{
                          maxHeight: 200,
                          width: "fit-content",
                          overflow: "auto",
                        }}
                      >
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList
                            data-testid="menuList1"
                            autoFocusItem={open}
                            id="composition-menu"
                            aria-labelledby="composition-button"
                            onKeyDown={handleListKeyDown}
                          >
                            {selectedPolicy &&
                              selectedPolicy.map((data, index) => (
                                <MenuItem
                                  data-testid={`menuItem${index}`}
                                  //data-testid="menuItem1"
                                  key={index}
                                  onClick={(e) => handleMenuItemClick(e, index)}
                                  aria-label={data.policy_name}
                                  style={{ padding: 0 }}
                                >
                                  <a
                                    className={classes.footerLinksPrivacyLink}
                                    href={data.policy_link}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ display: "flex" }}
                                    ref={(ref) => (linkRef[index] = ref)}
                                  >
                                    {data.policy_name}{" "}
                                    <OpenInNewIcon
                                      fontSize="small"
                                      style={{
                                        paddingLeft: "5px",
                                        alignSelf: "center",
                                      }}
                                    />
                                  </a>
                                </MenuItem>
                              ))}
                            {/* <MenuItem onClick={handleClose}>My account</MenuItem>
                        <MenuItem onClick={handleClose}>Logout</MenuItem> */}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Footer;
